import type { AppState } from '../../store/types';

export const CUTTING_ROOM_URL_REGEX =
  /^https:\/\/(?<tenant>[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*)\.(?<region>[a-zA-Z0-9-]+)\.cuttingroom\.com\/?$/;

export function parseCuttingRoomUrl(baseUrl: string):
  | {
      origin: string;
      region: string;
      tenant: string;
    }
  | undefined {
  const match = CUTTING_ROOM_URL_REGEX.exec(baseUrl.trim());
  if (!match?.groups) {
    return undefined;
  }

  const tenant = match.groups.tenant.toLowerCase();
  const region = match.groups.region.toLowerCase();

  return {
    origin: `https://${tenant}.${region}.cuttingroom.com`,
    region,
    tenant,
  };
}

export function normalizeCuttingRoomBaseUrl(
  baseUrl: string | null | undefined,
) {
  if (typeof baseUrl !== 'string') {
    return undefined;
  }

  return parseCuttingRoomUrl(baseUrl)?.origin;
}

/**
 * `undefined` both when the domain has no CuttingRoom URL and when the stored
 * one does not parse — the backend keeps the setting as a free-form string.
 */
export function selectCuttingRoomBaseUrl(state: AppState) {
  return normalizeCuttingRoomBaseUrl(state.settings.merged.cuttingroom_url);
}
